// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-container video {
  width: 100%;
  height: 600px;
}
.game-container .play {
  position: absolute;
  left: 0;
  right: 0;
  width: 200px;
  margin: 0 auto;
  bottom: 90px;
  z-index: 900;
}

@media (max-width: 767px) {
  .game-container video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    height: auto;
    width: 100% !important;
    height: auto !important;
    z-index: 500;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/campaign/play/play.component.scss"],"names":[],"mappings":"AAKI;EACI,WAAA;EACA,aAAA;AAJR;AAOI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;AALR;;AAUA;EAOQ;IACI,kBAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;IACA,WAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,YAAA;EAbV;AACF","sourcesContent":["@use '../../../../assets/styles/colors' as colors;\n@use '../../../../assets/styles/bootstrap-essentials';\n\n\n.game-container {\n    video {\n        width: 100%;\n        height: 600px;\n    }\n\n    .play {\n        position: absolute;\n        left: 0;\n        right: 0;\n        width: 200px;\n        margin: 0 auto;\n        bottom: 90px;\n        z-index: 900;\n    }\n}\n\n\n@media (max-width: 767px) { \n    .game-container {\n        // video {\n        //     width: 100%;\n        //     height: auto;\n        // }\n\n        video {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%,-50%);\n            width: auto;\n            height: auto;\n            width: 100% !important;\n            height: auto !important;\n            z-index: 500;\n        }\n    }\n    \n\n}\n\n@media (max-width: 1024px) {\n}\n\n@include bootstrap-essentials.media-breakpoint-up(lg) {}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
